import { render, staticRenderFns } from "./SalonModle.vue?vue&type=template&id=651f0f98&"
import script from "./SalonModle.vue?vue&type=script&lang=js&"
export * from "./SalonModle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports